import type { JSX } from 'solid-js';
import { GH_APP_INSTALL_URL } from '../lib/onboarding';
import { AccountReadiness } from './AccountReadiness';
import { OnboardingBuySeats } from './OnboardingBuySeats';
import { OnboardingDoneCard } from './OnboardingDoneCard';
import { OnboardingReachYou } from './OnboardingReachYou';

// The `active` screen: what the account still needs, then the hand-off card,
// then the two things the funnel ends WITHOUT and never mentioned — paid seats
// and how we reach you. Lifted out of the route so all of it stays under the
// 150-LOC cap.
export function OnboardingTerminal(props: { readonly token: string | null }): JSX.Element {
  return (
    <>
      {/* ABOVE the hand-off card, deliberately. Reaching `active` means the user
          walked the wizard's steps; it does not mean the account can run
          anything, and the funnel has no step that enrols a machine — so the
          ordinary outcome here is a done card over a blocked `scout_box` rung.
          The truth goes first and the congratulation second, or the reader acts
          on the congratulation. */}
      <AccountReadiness token={props.token} />
      <OnboardingDoneCard ghAppInstallUrl={GH_APP_INSTALL_URL} />
      {/* The maintainer loop is live but unpaid — offer the seats that add AI
          devs before the handoff (arc 101 slice 07); hides itself for an account
          that already has a plan. */}
      <OnboardingBuySeats token={props.token} />
      {/* The account is live — surface how we'll reach the user (defaults +
          this-device push opt-in) before the handoff; the topbar bell was the
          only enable path before (#57). */}
      <OnboardingReachYou />
    </>
  );
}
